<template>
    <div>
        <a-drawer
            :key="componentKey"
            width="550"
            :visible="optionsDrawerVisible"
            @close="onOptionsDrawerClose"
            >
            <h6 class="heading-small text-muted mb-4 text-truncate">{{currentWavelet.name}} - Settings</h6>    
            
            <a-tabs :default-active-key="activeTab">
                <a-tab-pane v-if="currentWavelet.web_wavelet != null"  key="1" tab="Web Wavelet">
                    <p class="h4">Set User Access</p>
                    <p v-if='currentAccountWebWavelet' style="line-height: 90%;"><small>Select users that can access this web wavelet. You can select up to {{currentAccountWebWavelet.concurrent_users}} users.</small></p>
                    <a-select
                        mode="multiple"
                        label-in-value
                        style="width: 100%"
                        placeholder="Please select users"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="searchUsers"
                        @change="selectUsers"
                        :value="selectedUsers"
                        @dropdownVisibleChange='userDropdown'
                    >
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="u in users" :key="u.id">{{u.name}}</a-select-option>
                    </a-select>
                </a-tab-pane>
                <a-tab-pane v-if="currentWavelet.pos_wavelet != null"  key="2" tab="POS Wavelet">
                    <p class="h4">Set Terminal Access</p>
                    <p v-if='currentAccountPosWavelet' style="line-height: 90%;"><small>Select terminals that can access this pos wavelet. You can select up to {{currentAccountPosWavelet.terminal_count}} terminals.</small></p>
                    <a-select
                        style="width: 100%"
                        mode="multiple"
                        placeholder="Please select a site"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @change="selectSites"
                        @dropdownVisibleChange="siteDropdown"
                        @search="searchSites"
                        :value='selectedSite'
                    >
                        <a-spin  class="d-flex justify-content-center" v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="s in sites" :key="s.id">{{s.name}}</a-select-option>
                    </a-select>
                    <br>
                    <br>
                    <a-select
                        mode="multiple"
                        allowClear
                        label-in-value
                        :value='selectedTerminals'
                        style="width: 100%"
                        placeholder="Please select terminals"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="searchTerminals"
                        @change="selectTerminals"
                    >
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="t in terminals" :key="t.id">{{t.name+' - ' + t.site_name}}</a-select-option>
                    </a-select>
                </a-tab-pane>
                <a-tab-pane v-if="currentWavelet.app_wavelet != null"  key="3" tab="App Wavelet">
                    HELLO
                </a-tab-pane>
            </a-tabs>
            
            
            <div v-if="currentWavelet.app_id != null">
                <h6 class="heading-small text-muted mb-4 text-truncate">{{currentWavelet.name}} - Device Management</h6>   
                <p class="h4">Set Device Access</p>
                <p v-if='currentAccountAppWavelet' style="line-height: 90%;"><small>Select devices that can access this app wavelet.You can select up to {{currentAccountAppWavelet.device_count}} terminals.</small></p>  
                <a-select
                        mode="multiple"
                        :value="selectedDevices"
                        label-in-value
                        style="width: 100%"
                        placeholder="Please select device"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="searchDevices"
                        @change="selectDevices"
                        @dropdownVisibleChange='userDropdown'
                    >
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="u in devices" :key="u.id">{{u.name}}</a-select-option>
                </a-select>  
            </div>

            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ; padding: 10px;">
                <button type="button" class="btn btn-success btn-block mt-2" @click="purchase(currentWavelet.id)">
                    Confirm 
                </button>
            </div>
        </a-drawer>

        <template v-if="updateMode == true">
            <h6 class="heading-small text-muted mb-4 text-truncate">{{currentWavelet.name}} - Device Management</h6>   
                <p class="h4">Set Device Access</p>
                <p v-if='currentAccountAppWavelet' style="line-height: 90%;"><small>Select devices that can access this app wavelet.You can select up to {{currentAccountAppWavelet.device_count}} terminals.</small></p>  
                <a-select
                        mode="multiple"
                        :value="selectedDevices"
                        label-in-value
                        style="width: 100%"
                        placeholder="Please select device"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="searchDevices"
                        @change="selectDevices"
                        @dropdownVisibleChange='userDropdown'
                    >
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="u in devices" :key="u.id">{{u.name}}</a-select-option>
                </a-select>  
            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ; padding: 10px;">
               <button type="button" class="btn btn-success btn-block mt-2" @click.prevent="updatePurchase">Update</button>
            </div>
        </template>

        <template v-else>
            <h6 class="heading-small text-muted mb-4 text-truncate">{{currentWavelet.name}}</h6>
            <table class="table table-borderless" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                <tbody>
                    <tr>
                        <td class="p-0 px-2 prevent-overflow" ><h2>{{currentWavelet.name}}</h2></td>
                        <td class="p-0 px-2 prevent-overflow text-right align-middle heading-small text-muted">current version: <strong>{{currentWavelet.version}}</strong></td>
                    </tr>
                    <tr>
                        <td class="p-0 px-2">{{currentWavelet.developer_account_name}}</td>
                        <td class='p-0 px-2 text-right' >
                            <a-rate style="fontSize: 2vh" :value="Math.round(Number(currentWavelet.average_rating))" disabled allow-half>
                                <a-icon slot="character" type="star"/>
                            </a-rate>
                        </td>
                    </tr>
                    <tr v-if="currentWavelet.tags">
                        <td colspan='2' class="p-0 px-2 pt-2 prevent-overflow">
                            <a-tag v-for="tags in currentWavelet.tags.split(',')" :key="tags" color="green">
                                {{tags}}    
                            </a-tag>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="col">{{currentWavelet.description}}</div>

            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ; padding: 10px;">
                <button v-if="isWaveletOwned" :disabled="true" type="button" class="btn btn-success btn-block mt-2">
                    Owned
                </button>
                <button v-else type="button" class="btn btn-success btn-block mt-2" @click="showOptionsDrawer">
                    Enable
                </button>
            </div>
        </template>

    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        props: ['updateMode','closeDrawer'],
        components: {
            
        },
        computed: {
            ...mapState(['endPoint', 'selectedWavelet']),
        },
        mounted: async function () {
            component_x = this
            this.currentWavelet = this.selectedWavelet
            this.isWaveletOwned = await this.checkWaveletIsOwned(this.currentWavelet.id);
            this.totalPrice = this.computeTotalPrice(this.currentWavelet.web_wavelet, this.currentWavelet.pos_wavelet);

            if (this.updateMode == true){
                if (this.currentWavelet.web_wavelet != null) {
                    var accountWebWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_web_wavelets/?web_wavelet_id='+this.currentWavelet.web_wavelet.id, null)
                    if (accountWebWavelet.data.length > 0) {
                        this.currentAccountWebWavelet = accountWebWavelet.data[0]
                    }
                }
                if (this.currentWavelet.pos_wavelet != null) {
                    var accountPosWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_pos_wavelets/?pos_wavelet_id='+this.currentWavelet.pos_wavelet.id, null)
                    if (accountPosWavelet.data.length > 0) {
                        this.currentAccountPosWavelet = accountPosWavelet.data[0]
                    }             
                }
                if (this.currentWavelet.app_wavelet != null) {
                    var accountAppWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_app_wavelets/?app_wavelet_id='+this.currentWavelet.app_wavelet.id, null)
                    if (accountAppWavelet.length > 0) {
                        console.log("------");
                        console.log(accountAppWavelet);
                        // alert(JSON.parse(accountAppWavelet[0]));
                        this.currentAccountAppWavelet = accountAppWavelet[0]
                    }             
                }

                var wavelet_payload = {"wavelet_id": this.currentWavelet.id}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/wavelet_is_owned', null, wavelet_payload)
                this.web_is_owned = post_request.web_is_owned;
                this.pos_is_owned = post_request.pos_is_owned;
                var selectedDevices = await HTTPRequest.getRequest(this.endPoint + 'account_app_wavelets/'+this.currentWavelet.app_id+'/get_devices', null)
                this.selectedDevices = selectedDevices
                var device_ids = selectedDevices.map(function (el) { return el.key; });
                var devices = await HTTPRequest.getRequest(this.endPoint + 'devices?id='+ device_ids, null)
                this.devices = devices.data
            }
        },
        data: function () {
            return {
                fetching: false, 
                componentKey: 0,
                optionsDrawerVisible: false,
                currentWavelet: {},
                activeTab: "3",
                selectedTerminals: [],
                selectedDevices: [],
                sites: [],
                selectedUsers: [],
                users: [],
                terminals: [],
                devices: [],
                totalPrice: 0,
                isWaveletOwned: false,
                web_is_owned: false,
                pos_is_owned: false,
                selectedSite: [],
                currentAccountWebWavelet: null,
                currentAccountPosWavelet: null,
                currentAccountAppWavelet: null,
            }
        },
        methods: {
            onDetailDrawerClose() {
                this.optionsDrawerVisible = false;
            },
            async showOptionsDrawer(){
                this.optionsDrawerVisible = true;
            },
            onOptionsDrawerClose(){
                this.optionsDrawerVisible = false;
            },
            async selectSites(value){
                this.fetching = true
                this.selectedSite = value
                var sites = await HTTPRequest.getRequest(this.endPoint + 'sites', null)
                this.sites = sites.data
                this.selectedTerminals = []
                this.loadTerminals(this.selectedSite)
                this.fetching = false
            },
            async searchTerminals(value){
                this.fetching = true;
                this.terminals = [];
                var terminals = await HTTPRequest.getRequest(this.endPoint + 'terminals?site_id='+this.selectedSite+'&code='+value, null)
                this.terminals = terminals.data
                this.fetching = false;
            },
            async selectTerminals(value){
                this.selectedTerminals = value
                this.loadTerminals(this.selectedSite);
            },
            async searchUsers(value){
                this.fetching = true;
                this.users = [];
                var users = await HTTPRequest.getRequest(this.endPoint + 'users?name='+value, null);
                this.users = users.data
                this.fetching = false;
            },
            async searchDevices(value){
                this.fetching = true;
                this.devices = [];
                var devices = await HTTPRequest.getRequest(this.endPoint + 'devices?name='+value, null);
                this.devices = devices.data
                this.fetching = false;
            },
            async searchSites(value){
                this.fetching = true;
                this.sites = [];
                var sites = await HTTPRequest.getRequest(this.endPoint + 'sites?name='+value, null);
                this.sites = sites.data
                this.fetching = false;
            },
            async siteDropdown(){
                this.sites = [];
                var sites = await HTTPRequest.getRequest(this.endPoint + 'sites', null);
                this.sites = sites.data
            },
            async checkWaveletIsOwned(wavelet_id){
                var is_owned = false;
                var wavelet_payload = {"wavelet_id": wavelet_id}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/wavelet_is_owned', null, wavelet_payload)
                is_owned = post_request.is_owned
                this.web_is_owned = post_request.web_is_owned;
                this.pos_is_owned = post_request.pos_is_owned;
                return is_owned;
            },
            computeTotalPrice(web_wavelet, pos_wavelet){
                var webPrice = 0
                var posPrice = 0

                if (web_wavelet != null) webPrice = web_wavelet.price
                if (pos_wavelet != null) posPrice = pos_wavelet.price
                
                if (this.web_is_owned) webPrice = 0
                if (this.pos_is_owned) posPrice = 0

                return (Number(webPrice) + Number(posPrice))
            },
            async loadTerminals(site_id){
                if(site_id.length > 0){
                    var terminals = await HTTPRequest.getRequest(this.endPoint + 'terminals?site_id='+site_id, null)
                    this.terminals = terminals.data
                }
            },
            async purchase(wavelet_id){
                var selectedDevicesId = []
                if (this.selectedDevices.length > 0){
                    this.selectedDevices.forEach(u => {selectedDevicesId.push(u.key)});
                }

                var selectedUserIds = []
                if (this.selectedUsers.length > 0){
                    this.selectedUsers.forEach(u => {selectedUserIds.push(u.key)});
                }
                var selectedTerminalIds = []
                if (this.selectedTerminals.length > 0){
                    this.selectedTerminals.forEach(t => {selectedTerminalIds.push(t.key)});
                }
                var wavelet_payload = {"wavelet_id": wavelet_id, "selected_user_ids": selectedUserIds, "pos_site_id": this.selectedSite, "selected_terminal_ids": selectedTerminalIds, "selected_device_ids": selectedDevicesId}
                // var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/purchase', null, wavelet_payload)

                // var selectedTerminalIds = []
                // if (this.selectedTerminals.length > 0){
                //     this.selectedTerminals.forEach(t => {selectedTerminalIds.push(t.key)});
                // }

                // var wavelet_payload = {"wavelet_id": wavelet_id, "selected_device_ids": selectedDevicesId}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/purchase', null, wavelet_payload)
                
                this.onDetailDrawerClose();
                
                if (post_request.status == 'success') {
                    this.$notification['success']({
                        message: 'App Marketplace',
                        description: "App was successfully enabled."
                    });
                } else {
                    this.$notification['error']({
                        message: 'App Marketplace',
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {post_request.error.split(',').map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        }
                    }); 
                }
                this.closeDrawer();
            },
            async selectUsers(value){
                this.selectedUsers = value;
                var users = await HTTPRequest.getRequest(this.endPoint + 'users', null)
                this.users = users.data
            },
            async selectDevices(value){
                this.selectedDevices = value;
                var devices = await HTTPRequest.getRequest(this.endPoint + 'devices', null)
                this.devices = devices.data
            },
            async userDropdown(){
                this.users = [];
                var users = await HTTPRequest.getRequest(this.endPoint + 'users', null);
                this.users = users.data
            },
            async updatePurchase(){
                var selectedUserIds = []
                if (this.selectedUsers.length > 0){
                    this.selectedUsers.forEach(u => {selectedUserIds.push(u.key)});
                }
                var selectedTerminalIds = []
                if (this.selectedTerminals.length > 0){
                    this.selectedTerminals.forEach(t => {selectedTerminalIds.push(t.key)});
                }
                

                var selectedDeviceIds = []
                if (this.selectedDevices.length > 0){
                    this.selectedDevices.forEach(u => {selectedDeviceIds.push(u.key)});
                }
                
                var wavelet_payload = {"wavelet_id": this.currentWavelet.id, "selected_user_ids": selectedUserIds, "pos_site_id": this.selectedSite, "selected_terminal_ids": selectedTerminalIds, "selected_device_ids": selectedDeviceIds,"module":"app"}
                // var wavelet_payload = {"wavelet_id": this.currentWavelet.id, "selected_device_ids": selectedDeviceIds}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'wavelets/update_purchase_settings', null, wavelet_payload)
                this.onOptionsDrawerClose();
                if (post_request.status == 'success') {
                    this.$notification['success']({
                        message: 'App Markeplace',
                        description: "Settings was updated successfully"
                    });
                } else {
                    this.$notification['error']({
                        message: 'Wavelet Marketplace',
                        description: "Purchase update error: " + post_request.error
                    }); 
                }
                this.closeDrawer()
            },
        }
    }
</script>

<style>
</style>